import styled from 'styled-components';

export const Container = styled.div`
	color: ${({ theme }) => theme.colors.neutral.white};
	font-size: 1.3rem;

	a {
		text-decoration: underline;

		&:hover {
			opacity: 0.8;
		}
	}

	@media (max-width: 768px) {
		font-size: 0.9rem;
	}
`;

export const NoLocation = styled.a`
	text-decoration: underline;

	&:hover {
		opacity: 0.7;
	}
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
`;

export const Name = styled.div`
	display: flex;
	align-items: center;

	& > *:not(:first-child) {
		margin: 0 0 0 8px;
	}
`;

export const NameLabel = styled.span`
	color: #ede7d8;

	@media (max-width: 768px) {
		&:first-child {
			display: none;
		}
	}
`;

export const NameValue = styled.a`
	font-weight: bold;
	text-transform: uppercase;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 768px) {
		font-size: 12px;
	}

	@media (max-width: 420px) {
		max-width: 100px;
	}

	@media (max-width: 390px) {
		max-width: 80px;
	}

	@media (max-width: 350px) {
		max-width: 60px;
	}
`;

export const Icon = styled.div`
	width: 16px;
	height: 16px;
`;

export const Chevron = styled.div`
	margin: 0 8px;
	width: 16px;

	@media (max-width: 768px) {
		display: none;
	}
`;

export const Open = styled.div`
	color: #ede7d8;

	@media (max-width: 768px) {
		display: none;
	}
`;

export const TableWait = styled.span`
	margin: 0 0 0 12px;
	position: relative;

	&::before {
		content: '/';
		position: absolute;
		left: -9px;
	}

	@media (max-width: 768px) {
		display: none;
	}
`;

export const Seating = styled.span`
	@media (max-width: 768px) {
		display: none;
	}
`;
